import { create } from "zustand";

import type { UserInfo } from "./auth.context.js";

type AuthBridgeTokenFunction = () => Promise<string | null>;

interface AuthBridgeStore {
  user: UserInfo | null;
  _getTokenFunction: AuthBridgeTokenFunction | null;
  _setAuthBridgeUser: (user: UserInfo) => void;
  _setAuthBridgeTokenFunction: (
    tokenFunction: AuthBridgeTokenFunction | null
  ) => void;

  getAccessToken: () => Promise<string | null>;
}

// ? This store serves as a bridge between AuthProvider and normal JS functions. Because the useAuth
// ? hook cannot be used outside of react components and we need it for API calls, this bridge is
// ? required.
// Note: It's responsibility of the AuthProvider to keep this up to date. Consumers should only read.
export const useAuthBridgeStore = create<AuthBridgeStore>((set, get) => ({
  _getTokenFunction: null,

  /**
   * @internal
   */
  _setAuthBridgeTokenFunction: (
    tokenFunction: AuthBridgeTokenFunction | null
  ) => {
    set({ _getTokenFunction: tokenFunction });
  },

  /**
   * @internal
   */
  _setAuthBridgeUser: (user: UserInfo) => {
    set({ user });
  },

  getAccessToken: () => {
    const { _getTokenFunction } = get();

    if (_getTokenFunction) {
      return _getTokenFunction();
    }

    return Promise.resolve(null);
  },
  user: null,
}));
